
<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-fire-extinguisher"></i><strong> {{$trans['general']['nav_fire_departments']}}</strong> <!-- <small>dropdown support</small> -->
			        </div>
			        <div>
						<b-row v-if="typeof id_item_selected === 'undefined'">
							<b-col md="12">
								<b-row>
									<b-col lg="6" class="p-0">
										<b-col md="12">
											<!-- <label for="choose-item">Escolher Concelho</label> -->
											<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
												<b-form-select id="choose-item" v-model="id_item_selected">
													<option :value="undefined">{{$trans[$route.meta.trans_key]['all_counties']}}</option>
													<option v-for="item in counties" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
												</b-form-select>
											</b-form-group>
										</b-col>
										<b-col md="12">
											<b-form-group :label="$trans[$route.meta.trans_key]['search_county']" :label-for="search1.id">
												<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="counties" v-on:choose-item="choose_item_search1"></autosuggest>
											</b-form-group>
										</b-col>
									</b-col>
									<b-col lg="6">
										<!-- <b-form-select class="opacity-0 pointer-events-none">
											<option></option>
										</b-form-select> -->
										<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
											<b-form-select>
												<option></option>
											</b-form-select>
										</b-form-group>
										<div>
											<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
												<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
													<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
												</b-form-select>
											</b-form-group>
										</div>
									</b-col>
								</b-row>
								<b-col md="12" class="p-0">
									<b-tabs pills class="text-capitalize">
										<b-tab :title="(maps_data1 != null && typeof maps_data1.map_data.markers !== 'undefined') ? $trans['general']['nav_fire_departments']+ ' (' +maps_data1.map_data.markers.length+ ')' : $trans['general']['nav_fire_departments']">
											<div class="loader-wrapper text-transform-none">
												<loader v-if="loading1"></loader>
												<div v-else>
													<div class="loader-wrapper">
														<loader v-if="loading1"></loader>
														<b-col cols="12" v-else-if="maps_data1 != null" class="my-map-leaflet-container p-0">
															<l-map-wrapper v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet"></l-map-wrapper>
														</b-col>
													</div>
												</div>
											</div>
										</b-tab>
									</b-tabs>
								</b-col>
							</b-col>
						</b-row>






						<b-row v-else>
							<b-col lg="6">
								<b-col sm="12" class="p-0">
									<b-form-group :label="$trans[$route.meta.trans_key]['county']" label-for="sel-county">
										<b-form-select id="choose-item" v-model="id_item_selected">
											<option :value="undefined">{{$trans[$route.meta.trans_key]['all_counties']}}</option>
											<option v-for="item in counties" :key="item.id" :value="item.id">{{item.name}}, {{item.district.name}}</option>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="12" class="p-0">
									<b-form-group :label="$trans[$route.meta.trans_key]['search_county']" :label-for="search1.id">
										<autosuggest v-bind:input="search1" v-bind:key_compare="'name'" v-bind:show="!loading1" v-bind:items="counties" v-on:choose-item="choose_item_search1"></autosuggest>
									</b-form-group>
								</b-col>
								<b-row>
									<b-col md="12">
										<b-tabs pills class="text-capitalize">
											<b-tab :title="$trans['general']['nav_fire_departments']+ ' (' +items1.length+ ')'">
												<b-col md="12" class="card-loader-container p-0">
													<loader v-if="loading1"></loader>
													<div v-else-if="items1.length === 0">
														<h6>{{$trans[$route.meta.trans_key]['no_results']}}</h6>
													</div>
													<div v-else>
														<div class="d-lg-none d-block">
															<b-list-group class="mobile-list">
	 															<b-list-group-item class="cursor-pointer" v-on:click.prevent="change_item(item)" v-for="(item, key) in items1" :key="key">{{item.corpo_bombeiros}}</b-list-group-item>
															</b-list-group>
														</div>
														<div class="list-group d-lg-block d-none">
															<div v-on:click.prevent="change_item(item)" v-for="(item, key) in items1" :key="key">
																<b-btn v-b-toggle="'item_'+key" :class="(opened_item && item1_selected.id == item.id) ? 'active' : ''" :aria-controls="'item_'+key" :aria-expanded="(opened_item && item1_selected.id == item.id) ? 'true' : 'false'" class="white-space-normal list-group-item list-group-item-action">{{item.corpo_bombeiros}}</b-btn>
		  														<b-collapse class="p-3" :id="'item_'+key" :visible="opened_item && item1_selected.id == item.id">
																	<div v-on:click.stop="">
																		<div class="text-center p-3">
																			<img class="local-badge" :src="assets_url+ 'images/badges_fire_departments/' +item.badge">
																		</div>
																		<p><b>Corpo de Bombeiros</b>: {{item.corpo_bombeiros}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item.address}}</p>
																		<p><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></p>
																		<p><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
																		</p>
																		<p><b>{{$trans[$route.meta.trans_key]['phone']}}</b>: {{item.phone}}</p>
																		<p><b>Email</b>: <a :href="'mailto:' +item.email">{{item.email}}</a></p>
																		<p><b>Website</b>: <a target="_blank" :href="'//' +item.website">{{item.website}}</a></p>
																		<p><b>{{$trans[$route.meta.trans_key]['details']}}</b>: <a target="_blank" :href="item.href">bombeiros.pt</a></p>
																		<p><b>CDOS</b>: {{item.CDOS}}</p>
																		<!-- <p><b>Sede concelho</b>: {{item.num_fireman}}</p> -->
																		<p><b>Num. Bombeiros</b>: {{item.num_fireman}}</p>
																		<p><b>Zona operacional</b>: {{item.operational_zone}}</p>
																		<p><b>Área Oper. (km2)</b>: {{item.area_operations}}</p>
																		<p><b>Salv. Grande Angulo</b>: {{item.salv_grande_angulo}}</p>
																		<p><b>Tipificação</b>: {{item.tipification}}</p>
																		<p><b>Fanfarra</b>: {{item.fanfarra}}</p>
																		<p><b>Veículos</b>: {{item.vehicles}}</p>
																		<p><b>Mergulhadores</b>: {{item.divers}}</p>
																		<p><b>Latitude</b>: {{item.latitude}}</p>
																		<p><b>Longitude</b>: {{item.longitude}}</p>
		   															</div>
																</b-collapse>
															</div>
														</div>
													</div>
												</b-col>
											</b-tab>
								        </b-tabs>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6" v-if="!is_mobile()">
								<b-col md="12" class="p-0">
									<!-- <b-form-select class="opacity-0 pointer-events-none">
										<option></option>
									</b-form-select> -->
									<b-form-group label="hidden-inp" class="invisible d-lg-block d-none">
										<b-form-select>
											<option></option>
										</b-form-select>
									</b-form-group>
									<div>
										<b-form-group :label="$trans[$route.meta.trans_key]['map_style']" label-for="sel-map-style">
											<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
												<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
											</b-form-select>
										</b-form-group>
									</div>
								</b-col>
								<b-col md="12" class="p-0">
									<b-tabs pills class="text-capitalize">
										<b-tab :title="$trans[$route.meta.trans_key]['map']">
											<div class="loader-wrapper text-transform-none">
												<loader v-if="loading1"></loader>
												<h5 v-else-if="item1_selected === null" class="select_text align-center">{{$trans[$route.meta.trans_key]['select_result_box']}}</h5>
												<l-map-wrapper class="my-map-leaflet" v-else-if="maps_data1 != null && item1_selected !== null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:mapType="'markerCluster'" v-bind:func_setMarkerInfo="setMarkerInfo"></l-map-wrapper>
											</div>
										</b-tab>
									</b-tabs>
								</b-col>	
							</b-col>
						</b-row>
			        </div>
			    </b-card>
			</b-col>
		</b-row>
		<div v-if="is_mobile()" class="d-lg-none d-block">
			<modal v-if="item1_selected !== null" v-on:close="item1_selected = null">
				<div slot="header"><h6>{{item1_selected.corpo_bombeiros}}</h6>
				</div> 
				<div slot="body">
					<div class="min-height-45">
						<b-form-select id="sel-map-style" v-model="map.style" text="Estilo do mapa" right>
							<option v-for="(item, idx) in map.styles" :key="idx" :value="item">{{item.name}}</option>
						</b-form-select>
					</div>
					<l-map-wrapper v-if="maps_data1 != null" v-bind:data="maps_data1" v-bind:mapStyle="map.style" v-on:setStyles="setMapStyles" v-bind:func_setMarkerInfo="setMarkerInfo" v-bind:mapType="'markerCluster'" class="my-map-leaflet map-modal"></l-map-wrapper>
					<b-list-group class="mobile-list">
						<b-list-group-item class="text-center"><img class="local-badge" :src="assets_url+ 'images/badges_fire_departments/' +item1_selected.badge"></b-list-group-item></b-list-group>
						<b-list-group-item><b>Corpo de Bombeiros</b>: {{item1_selected.corpo_bombeiros}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['address']}}</b>: {{item1_selected.address}}</b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['district']}}</b>: <router-link :to="base_url+ '/div-admin/distritos/' +county_selected.district.id"> {{county_selected.district.name}}</router-link></b-list-group-item>
						<b-list-group-item><b>{{$trans[$route.meta.trans_key]['county']}}</b>: <router-link :to="base_url+ '/div-admin/concelhos/' +id_item_selected"> {{county_selected.name}}</router-link>
						</b-list-group-item>
						<b-list-group-item><b>Telefone</b>: {{item1_selected.phone}}</b-list-group-item>
						<b-list-group-item><b>Email</b>: <a :href="'mailto:' +item1_selected.email">{{item1_selected.email}}</a></b-list-group-item>
						<b-list-group-item><b>Website</b>: <a target="_blank" :href="'//' +item1_selected.website">{{item1_selected.website}}</a></b-list-group-item>
						<b-list-group-item><b>Detalhes</b>: <a target="_blank" :href="item1_selected.href">bombeiros.pt</a></b-list-group-item>
						<b-list-group-item><b>CDOS</b>: {{item1_selected.CDOS}}</b-list-group-item>
						<!-- <b-list-group-item><b>Sede concelho</b>: {{item1_selected.num_fireman}}</b-list-group-item> -->
						<b-list-group-item><b>Num. Bombeiros</b>: {{item1_selected.num_fireman}}</b-list-group-item>
						<b-list-group-item><b>Zona operacional</b>: {{item1_selected.operational_zone}}</b-list-group-item>
						<b-list-group-item><b>Área Oper. (km2)</b>: {{item1_selected.area_operations}}</b-list-group-item>
						<b-list-group-item><b>Salv. Grande Angulo</b>: {{item1_selected.salv_grande_angulo}}</b-list-group-item>
						<b-list-group-item><b>Tipificação</b>: {{item1_selected.tipification}}</b-list-group-item>
						<b-list-group-item><b>Fanfarra</b>: {{item1_selected.fanfarra}}</b-list-group-item>
						<b-list-group-item><b>Veículos</b>: {{item1_selected.vehicles}}</b-list-group-item>
						<b-list-group-item><b>Mergulhadores</b>: {{item1_selected.divers}}</b-list-group-item>
						<b-list-group-item><b>Latitude</b>: {{item1_selected.latitude}}</b-list-group-item>
						<b-list-group-item><b>Longitude</b>: {{item1_selected.longitude}}</b-list-group-item>
					</b-list-group>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import LMapWrapper from '@/views/sub_components/LMapWrapper';

export default {
	name: 'Fire_Departments',
	components: {
		LMapWrapper
	},
	data() {
		return {
			items1: [],
			loading1: true,
			counties: [],
			id_item_selected: this.$route.params.id,
			county_selected: null,
			search1: {
				id: 'search-county',
				value: '',
				has_error: false,
				placeholder: this.$trans[this.$route.meta.trans_key]['county'],
				error: this.$trans[this.$route.meta.trans_key]['county']+ ' não encontrado'
			},
			item1_selected: null,
			opened_item: false,
			maps_data1: null,
			map: {style: null, styles: []}
		}
	},
	methods: {
		get_items: function(url) {
			const that = this;
			that.get_req(url,
				function() { // before
					that.loading1 = true;
					/*that.loading2 = false;*/
	            },
				function(response) { // success
					that.maps_data1 = response.body.data.map;
					that.items1 = response.body.data.items;
					that.loading1 = false;
					/*that.loading2 = false;*/
					
				},
				function(response) { // fail
					console.log(response);
					that.loading1 = false;
					
				},
				function(response) {
					
				}
			);
		},
		change_item: function(item) {
			if(this.item1_selected === item) {
				this.item1_selected = null;
				return;
			}
			this.item1_selected = item;
			this.maps_data1.map_data.markers = [item]
			this.maps_data1.map_data.longitude = item.longitude;
			this.maps_data1.map_data.latitude = item.latitude;
		},
		do_search1: function() {
			if(this.search1.value.trim() !== '') {
				var item_selected_tmp = this.counties.find((item, idx) => item.name == this.search1.value || item.name.toLowerCase() == this.search1.value.toLowerCase());
				if(typeof item_selected_tmp === 'undefined') {
					this.search1.has_error = true;
					return;
				}
				this.id_item_selected = item_selected_tmp.id;
				this.search1.has_error = false;
			}
		},
		setMapStyles: function(styles) {
			this.map.styles = styles;
			if(this.map.style === null)
				this.map.style = styles[3];
		},
		setMarkerInfo: function(item) {
			return '<img style="display: block; margin: 10px auto; max-width: 100px;" src="' +this.assets_url+'images/badges_fire_departments/'  +item.badge+ '" />\
			<p style="font-weight: bold; margin: 0;">' +item.corpo_bombeiros+ '</p>\
			<p style="margin: 0;">\
			    <b>' +this.$trans[this.$route.meta.trans_key]['address']+ ': </b>' +item.address+ '<br />\
			    <b>' +this.$trans[this.$route.meta.trans_key]['phone']+ ': </b>' +item.phone+ '<br />\
			    <b>email: </b> <a href="mailto:' +item.email+ '">' +item.email+ '</a><br />\
			    <b>Website: </b> <a href="//www.bombeirosdealbergaria.pt" target="_blank">www.bombeirosdealbergaria.pt</a><br />\
			    <b>' +this.$trans[this.$route.meta.trans_key]["details"]+ ': </b> <a href="' +item.href+ '" target="_blank">www.bombeiros.pt</a><br />\
			</p>';
		}
	},
	watch: {
		/*len_items: function(new_val, old_val) {
			if(new_val === 0) {
				this.item_selected = null;
			}
		},*/
		id_item_selected: function(new_val, old_val) {
			this.item1_selected = null;
			this.search1.value = '';
			if(typeof new_val === 'undefined') {
				this.items1 = []; // no waiting for the response
				this.county_selected = null;
				this.get_items('fire-departments');
				return;
			}
			this.get_items('fire-departments/' +new_val);
			this.county_selected = this.counties.find((item, key) => item.id == new_val);
		},
		'$route.params.id_county': function(new_val, old_val) {
			if(this.id_item_selected != new_val) {
				this.id_item_selected = new_val;
			}
		},
		item1_selected: function(new_val, old_val) {
			this.opened_item = new_val != null;
		},
		loading1: function(new_val, old_val) {
			if(!new_val) {
				let params = this.$route.params;
				if(this.county_selected !== null) {
					params.id_county = this.id_item_selected;
					params.slug = this.county_selected.slug;
				}
				else {
					params = {lang: this.$lang};
				}
				this.$router.push({name: 'Fire_Departments', params: params});
			}
		},
	},
	computed: {

	},
	created: function() {
		this.id_item_selected = this.$route.params.id_county;
		if(this.globs['fire_dep_counties'] !== null) {
			this.counties = this.globs['fire_dep_counties'];
			if(typeof this.id_item_selected === 'undefined') {
				this.get_items('fire-departments');
				return;
			}
			this.id_item_selected = this.get_starter_item(this.globs['fire_dep_counties'], this.id_item_selected).id;
			return;
		}
		const that = this;
		that.get_req('fire-departments/counties',
			function() { // before
				//that.loading = true;
            },
			function(response) { // success
				that.counties = response.body;
				that.globs['fire_dep_counties'] = that.counties;
				if(typeof that.id_item_selected == 'undefined') {
					that.get_items('fire-departments');
				}
				else {
					that.id_item_selected = that.get_starter_item(that.counties, that.id_item_selected).id;
				}
			},
			function(response) { // fail
				alert('ajax main.js error: '+ response.status);
			},
			function(response) {
				
			});
	},
}
</script>
<style scoped>
  @import '~leaflet/dist/leaflet.css';
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style>
   .my-map-leaflet {
		width: 100%;
		height: 100%;
	}
  .my-map-leaflet .leaflet-popup-content-wrapper {
    border-radius: 5px;
  }
  .map-info-window {
    font-size: 12px;
  }
  .map-info-window table {
    border-collapse: collapse;
  }
  .map-info-window th {
    padding: 6px;
    font-size: 13px;
  }
  .map-info-window td {
    padding: 2px 6px;
    font-size: 12px;
  }
  .map-info-window td, .map-info-window th {
    text-align: center;
    border: 1px solid #747474;
  }
</style>